export default __webpack_public_path__ + "static/media/gifts.f2396b35.webp";